<template>
	<div class="input-container">
		<h2>{{ languageStrings.enterPassword }}</h2>
		<small class="center-text"
			>{{ languageStrings.passwordRequirements1 }} {{ serverRules?.passwordRules?.minimumLength }}
			{{ languageStrings.passwordRequirements2 }}
			<span v-if="serverRules?.passwordRules?.minimumNumberOfCharacterClasses > 0">
				{{ languageStrings.passwordRequirements3 }}
				{{ serverRules?.passwordRules?.minimumNumberOfCharacterClasses }}
				{{ languageStrings.passwordRequirements4 }}
			</span>
		</small>
		<div class="password-container">
			<input
				class="curved-border extra-padding-text-fields"
				:type="unhidePassword ? 'text' : 'password'"
				:placeholder="languageStrings.password"
				v-model="password"
				autocomplete="off"
			/>
			<span
				@click="unhidePassword = unhidePassword ? false : true"
				:class="unhidePassword ? 'hidden' : ''"
				:title="unhidePassword ? languageStrings.hidePassword : languageStrings.showPassword"
			>
				<svg width="35px" height="28px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
					<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
					<g id="SVGRepo_iconCarrier">
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M12.0002 5C9.89024 5 7.99432 5.92747 6.49128 7.00884C4.98034 8.0959 3.78013 9.40024 3.04026 10.2985C2.21965 11.2948 2.21965 12.7052 3.04026 13.7015C3.78013 14.5998 4.98034 15.9041 6.49128 16.9912C7.99432 18.0725 9.89024 19 12.0002 19C14.1101 19 16.006 18.0725 17.5091 16.9912C19.02 15.9041 20.2202 14.5998 20.9601 13.7015C21.7807 12.7052 21.7807 11.2948 20.9601 10.2985C20.2202 9.40025 19.02 8.0959 17.5091 7.00885C16.006 5.92747 14.1101 5 12.0002 5ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z"
							fill="#6305C9"
						>
					</path>
					</g>
				</svg>
			</span>
		</div>
		<div class="password-container">
			<input
				class="curved-border extra-padding-text-fields"
				:type="unhideConfirmPassword ? 'text' : 'password'"
				:placeholder="languageStrings.confirmPassword"
				v-model="confirmPassword"
				autocomplete="off"
			/>
			<span
				@click="unhideConfirmPassword = unhideConfirmPassword ? false : true"
				:class="unhideConfirmPassword ? 'hidden' : ''"
				:title="unhideConfirmPassword ? languageStrings.hidePassword : languageStrings.showPassword"
			>
				<svg width="35px" height="28px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
					<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
					<g id="SVGRepo_iconCarrier">
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M12.0002 5C9.89024 5 7.99432 5.92747 6.49128 7.00884C4.98034 8.0959 3.78013 9.40024 3.04026 10.2985C2.21965 11.2948 2.21965 12.7052 3.04026 13.7015C3.78013 14.5998 4.98034 15.9041 6.49128 16.9912C7.99432 18.0725 9.89024 19 12.0002 19C14.1101 19 16.006 18.0725 17.5091 16.9912C19.02 15.9041 20.2202 14.5998 20.9601 13.7015C21.7807 12.7052 21.7807 11.2948 20.9601 10.2985C20.2202 9.40025 19.02 8.0959 17.5091 7.00885C16.006 5.92747 14.1101 5 12.0002 5ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z"
							fill="#6305C9"
						>
					</path>
					</g>
				</svg>
			</span>
		</div>
		<div class="encore-style-button-container">
			<button
				class="btn curved-border encore-style-button"
				:title="
					(!password.length > 0 && !confirmPassword.length > 0) || password !== confirmPassword
						? languageStrings.passwordsMustMatch
						: languageStrings.continueText
				"
				@click="submitToParent()"
			>
				{{ languageStrings.registerText }}
			</button>
		</div>
		<div class="encore-style-button-container">
			<button
				class="btn curved-border encore-style-button"
				:title="languageStrings.back"
				@click="goBackToPreviousPage()"
			>
				{{ languageStrings.back }}
			</button>
		</div>
		<small
			v-if="(!password.length > 0 && !confirmPassword.length > 0) || password !== confirmPassword"
			class="warn"
		>
			{{ languageStrings.passwordsMustMatch }}
		</small>
		<div id="pw-strength-container">
			<p>
				{{ languageStrings.passwordStrength }}:
				<span
					v-if="password?.length > 0 && strengthCheck == 'weak'"
					class="score-words"
					:class="strengthCheck"
					>{{ languageStrings.weak }}</span
				>
				<span
					v-if="password?.length > 0 && strengthCheck == 'medium'"
					class="score-words"
					:class="strengthCheck"
					>{{ languageStrings.medium }}</span
				>
				<span
					v-if="password?.length > 0 && strengthCheck == 'strong'"
					class="score-words"
					:class="strengthCheck"
					>{{ languageStrings.strong }}</span
				>
			</p>
			<progress id="pw-strength" class="custom-bar" :class="strengthCheck" :value="pwStrength" max="100">
				{{ languageStrings.passwordStrength }}
			</progress>
		</div>
	</div>
</template>

<script>
export default {
	name: "PasswordForm",
	props: {
		serverRules: Object,
		languageStrings: Object,
		languageErrorStrings: Object,
	},
	components: {},
	data() {
		return {
			status: Object.assign({}, this.globalStatus),
			password: "",
			confirmPassword: "",
			pwStrength: 0,
			newAccountProperty: {
				propertyName: "",
				propertyValue: "",
				componentName: "PasswordForm",
			},
			unhidePassword: false,
			unhideConfirmPassword: false,
		};
	},
	watch: {
		password() {
			this.passwordStrengthCheck();
		},
		confirmPassword() {
			this.passwordStrengthCheck();
		},
	},
	created() {},
	mounted() {},
	methods: {
		passwordStrengthCheck() {
			this.pwStrength = this.scorePassword(this.password);

			if (this.pwStrength <= 33) this.strengthCheck = "weak";
			if (this.pwStrength > 33 && this.pwStrength < 66) this.strengthCheck = "medium";
			if (this.pwStrength >= 66) this.strengthCheck = "strong";

			if (
				this.password === this.confirmPassword &&
				this.password.length >= this.serverRules.passwordRules?.minimumLength
			) {
				this.matchedCharClasses = this.characterClassCheck(
					this.password,
					this.serverRules.passwordRules?.minimumNumberOfCharacterClasses
				);
				this.validNumberCharClasses = this.matchedCharClasses.characterClassesValid;
			}
		},
		submitToParent() {
			if (
				(!this.password.length > 0 && !this.confirmPassword.length > 0) ||
				this.password !== this.confirmPassword
			) {
				this.status.ok = false;
				this.status.message = this.languageErrorStrings.passwordDoNotMatch;
				this.eventBus.emit("updateStatus", this.status);
				return false;
			}

			// if (this.password.length >= this.serverRules.passwordRules?.minimumLength) {
			// 	this.status.ok = false;
			// 	this.status.message = this.languageErrorStrings.passwordDoNotMatch;
			// 	this.eventBus.emit("updateStatus", this.status);
			// 	return false;
			// }

			this.newAccountProperty.propertyName = "password";
			this.newAccountProperty.propertyValue = this.password;
			this.eventBus.emit("addNewAccountProperty", this.newAccountProperty);

			this.eventBus.emit("advanceComponent");
		},
		goBackToPreviousPage() {
			this.eventBus.emit("goBackOnePage");
		}
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input-container {
	display: flex;
	flex-direction: column;
	margin: 15px auto;
	padding: 15px;
	max-width: 30em;
}

input {
	font-size: 1.5em;
	border-radius: 12px;
	color: #6305c9;
	height: 30px;
}

small {
	font-size: 1rem;
}

button.btn:disabled {
	/* background-color: light-dark(rgba(239, 239, 239, 0.3), rgba(19, 1, 1, 0.3)) !important; */
	color: light-dark(rgba(16, 16, 16, 0.3), rgba(255, 255, 255, 0.3)) !important;
	border-color: light-dark(rgba(118, 118, 118, 0.3), rgba(195, 195, 195, 0.3)) !important;
}

.encore-style-button-container {
	margin-top: 20px;
	margin-bottom: 10px;
}

.btn {
	height: 40px;
}
.password-container span {
	color: #6305c9;
	top: 8px;
}

.password-container span::after{
	right: 13px;
	top: -4px;
}
</style>
